<template>
  <div class="c-title-content">
    <h1 class="c-title c-title--h01">
      <Icon :variant="'project_' + icon" :size="28" radius />
      <slot></slot>
    </h1>
    <template>
      <div class="c-title-content__btns">
        <Button
          v-if="howTo"
          :href="howToUrl"
          target="_blank"
          size="w145"
          fsizse="f14"
          variant="dark"
          radius
        >
          機能の使い方
        </Button>
        <Button
          v-if="!this.isFaqHide || this.isFaqHide !== true"
          :href="faqUrl"
          target="_blank"
          size="w145"
          fsizse="f14"
          variant="dark"
          icon="faq"
          radius
        >
          よくある質問
        </Button>
      </div>
    </template>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon from '@/components/Icon';
export default {
  props: {
    faq: {
      type: String,
      required: false
    },
    howTo: {
      type: String,
      required: false
    },
    isFaqHide: {
      type: Boolean,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  },
  components: {
    Button,
    Icon
  },
  computed: {
    faqUrl() {
      let url = `${this.$constants.supportDeskSiteUrl}`;
      if (this.faq) {
        url += this.faq;
      }
      return url;
    },
    howToUrl() {
      let url = `${this.$constants.supportDeskSiteUrl}`;
      if (this.howTo) {
        url += this.howTo;
      }
      return url;
    }
  }
};
</script>
